import { Outlet, useNavigation } from "react-router";
import { KeepAliveIdP } from "./KeepAliveIdP/KeepAliveIdP";
import {
  getStatusPageData,
  KNOWN_COMPONENT_IDS,
  StatusPageInfo,
} from "@digipost/statusbanner/dist/src";
import { StatusBanner } from "./StatusBanner/StatusBanner";
import { useEffect, useState } from "react";
import { DocumentTitle } from "./DocumentTitle/DocumentTitle";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { NavigationProgress } from "./NavigationProgress/NavigationProgress";

function App() {
  const [statusList, setStatusList] = useState<StatusPageInfo[]>([]);
  const navigation = useNavigation();

  useEffect(() => {
    getStatusPageData([
      KNOWN_COMPONENT_IDS.DIGIPOST_WEB,
      KNOWN_COMPONENT_IDS.SIGNERING_WEB,
    ]).then(setStatusList);
  }, []);

  return (
    <>
      <StatusBanner statusPageInfo={statusList} />
      <Header />
      <DocumentTitle />
      {navigation.state === "loading" && <NavigationProgress />}
      <div className="app-content">
        <Outlet />
      </div>
      <KeepAliveIdP />
      <Footer />
    </>
  );
}

export default App;
